<script>
import Dialog from '@components/dialogs'
import OffCanvas from '@components/offcanvas'
import JobList from './list/jobList.vue'

import error from '@utils/error'

export default {
  components:{
    Dialog,
    OffCanvas,
    JobList,
  },
  props:['userData'],
	data() {
		return {
			title: this.$t('job.plural'),
			items: [],
      jobStatus: 'All',
			filter: null,
      params: {},
			sortBy: 'date_created',
			sortDesc: true,
      submitted: false,
      isBusy:false,
      jobID: '',
      filterItems: {},
      listType: 'card', //card much default
		}
	},
	computed: {
    computedEditJobComponent() {
      return () => import('../pages/job/components/dialogs/edit.vue')
    },
    computedViewJobComponent() {
      return () => import('../pages/job/components/dialogs/view.vue')
    }
	},
	methods: {
    onClickViewActions(val) {
      this.jobID = val.data._id

      if (val && val.type && val.type.toLowerCase() == 'ref') {
        this.$refs[val.ref].show()
      }
      else if (val && val.type && val.type.toLowerCase() == 'function') {
        this[val.func](val.data)
      }
    },
    onUpdateJobs(val) {
      this.submitted = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id

      return this.$store.dispatch('job/update', model)
      .then(res => {
        if (res && res.data) {
          this.fetchData()
          this.$refs.edit_side_bar.hide()
          this.$bvToast.toast(`${res.data.job.title} successfully updated!`, {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.submitted = false;
          }, 1500)
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    async fetchData(reload = false, type = 'active', useProps = true, hrflow = false) {
      this.items = []
      if(!reload)
        this.toggleBusy()
        
      if(useProps)
        type = this.type

      let skip = this.currentPage <= 1 ? 0 : (this.currentPage - 1) * this.perPage
      let params = {}
      let items = this.filterItems
      let min = ''
      if(items.sortBy) {
        this.sortBy = items.sortBy
        this.sortDesc = items.isDesc
        min = this.sortBy != 'update_at' ? '0' : ''
      }

      if(items.startDate || items.endDate) {
        params.created_at_min = this.params.created_at_min || items.startDate || ''
        params.created_at_max = this.params.created_at_max || items.endDate || ''
      }

      params.limit = this.perPage
      params.start = skip
      params.brand_id = items.brand_id || ''
      // params.status = items.status || ''
      params.rate = items.commission || ''
      params.minimum = items.minimumSalary || min || ''
      params.maximum = items.maximumSalary || ''
      params.filter = this.filter || items.filter || ''
      params.type = type
      params.job_status = this.hasFilter && items.status ? items.status : this.jobStatus
      params.sort_by = this.sortBy
      params.sort_desc = this.sortDesc
      if(this.userData.functions){
        params.function_id = this.userData.functions[0]?._id ||  '000000000000000000000000'
      }else{
        params.function_id = '000000000000000000000000'// blank id 
      }
      if(hrflow){
        params = {
          ...params,
          ...this.params
        }
      }

      this.$store.dispatch('job/pagination', { ...params })
      .then(res => {
        this.items = res.data.data
        this.toggleBusy()
      })

      return this.items
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },
    openFormBar(id, editMode = false) {
      this.jobID = id
      if(!editMode){
        this.$refs.view_side_bar.show()
        // this.$refs.edit_side_bar.hide()
      }else{
        // this.$refs.edit_side_bar.show()
        this.$refs.view_side_bar.hide()
        this.$router.push({path: '/job/edit', query: { id: id }})
      }
    },
    onGenerateUrl(job){
      let jobs = this.items
      for(let key in jobs){
        if(jobs[key]._id == job.id){
          if (job.is_company) jobs[key].job_company_url = job.url
          else jobs[key].job_url = job.url
        }
      }

      this.items = jobs
    },
  },
  mounted() {
   this.fetchData();
  },
}
</script>
<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
                <JobList 
                  v-if="items.length"
                  :listType="listType"
                  :items="items"
                  @onView="openFormBar"
                  @fetchData="fetchData"
                  @onGenerateUrl="onGenerateUrl"
          
                />
                <div v-else>
                  <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-5 col-8">
                      <div class="text-center">
                        <div>
                          <img src="../../assets/images/not-found.png" alt class="img-fluid" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 text-center">
                      <h3 class="mt-3">No Suitable Jobs.</h3>
                      <p class="text-muted mb-5">
                        No suitable jobs for this candidate.
                        <br />The candidate has no selected functions or no job has available slots.
                      </p>
                    </div>
                  </div>
                </div>
        </div>
      </div>
    </div>

    <OffCanvas
      width="1200"
      centered
      title="View Job"
      ref="view_side_bar"
      bodyClass="modalBodyContainer px-4"
      size="xl"
      :component="computedViewJobComponent"
      :parameters="{ jobID, submitted }"
      @onClick="onClickViewActions"
    />
    <Dialog
      autoload
      centered
      yesText="Update"
      noText="Cancel"
      title="Update Job(s)"
      ref="edit_side_bar"
      size="xl"
      :component="computedEditJobComponent"
      :parameters="{ jobID }"
      @onYes="onUpdateJobs"
    />
  </div>
</template>

<style lang="scss">
  .modalBodyContainer {
    background: #e8eaee;
    overflow: auto;
    height: 80vh;
  }

</style>